// Global
import i18next from 'i18next';
import _ from 'lodash';

// Common
import Utils from '../../Utils';
import {
  EventDetail, 
  RUNNING_STATE_EXTRA_TIME,
  EventPeriodHDPOU,
  BetTypeGroup,
  OddsFormat,
  OddsConstant} from '../../Foundation';
import Constants from '../../Constants';

export const renderHeader = (event, runningState, score, redCards = [0, 0], ) => {
  const [homeRedCard, awayRedCard] = runningState && redCards ? redCards : [0, 0] ;
  return `
    <div class='event-header extra-time-header'>
      <div class='team'>
        <div class="t-n h">
          <div class='team-name'>
            <span class='name'>${event[EventDetail.homeName]}</span>
            ${homeRedCard ?
              `<i class="card redCard">${homeRedCard}</i>` : ''}
          </div>
        </div>
        <div class='score'>
          ${runningState
            ? `
              <span class='score-detail'>
                ${score && score.length > 0 ? `${score[0]}-${score[1]}` : ''}
              </span>
              <br/><span>${i18next.t(runningState)} ${event[EventDetail.runningTime] || ''}</span>`
            :`<span class="vs">${i18next.t('vs')}</span>`}
        </div>
        <div class="t-n a">
          <div class='team-name'>
            ${awayRedCard ?
              `<i class="card redCard">${awayRedCard}</i>` : ''}
            <span class='name'>${event[EventDetail.awayName]}</span>
          </div>
        </div>
      </div>
    </div>
  `
}

export const getOddsML = (_ml, eventId, period, oddsFormat, dataTeam, lineIndex = 0, classParlayRestriction = '') => {
  let result = '';
  const isMLOnline = _ml && _ml[1] !== '';
  if(lineIndex === 0) {
    for(const oddsML of OddsConstant.mlType) {
      result += 
        `<div>
          <span class='type'>${oddsML.id === 0 ? i18next.t('H') : i18next.t('A')}</span>
          ${ _ml 
            ? 
              `<a class="odds-btn ${isMLOnline ? '' : 'offline-game'} ${_ml[oddsML.oddData] < 0 ? 'neg' : ''}"
                data-oddsid="${_ml[3]}"
                data-odds="${_ml[oddsML.oddData]}"
                data-bettype="${BetTypeGroup.ML_1X2}"
                data-team="${dataTeam[oddsML.id]}"
                ${classParlayRestriction}
                id="${eventId}|${period}|1|${oddsML.selectionType}|${_ml[4] ? 1 : 0}|0"
              >
                <h4>
                  ${oddsFormat === OddsFormat.American && _ml[oddsML.oddData] > 0 ? '+': ''}
                  ${_ml[oddsML.oddData]}
                </h4>
              </a>`
            : `<span class='no-odds ml'></span>`
          }
        </div>`
    }
    if(_ml && _ml[2]) {
      result += 
        `<div>
          <span class="type">${i18next.t('D')}</span>
            <a class="odds-btn ${isMLOnline ? '' : 'offline-game'} ${_ml[2] < 0 ? 'neg' : ''}"
              data-oddsid="${_ml[3]}"
              data-odds="${_ml[2]}"
              data-bettype="${BetTypeGroup.ML_1X2}"
              data-team="2"
              ${classParlayRestriction}
              id="${eventId}|${period}|1|2|${_ml[4] ? 1 : 0}|0"
            >
              <span>
                <h4>
                  ${oddsFormat === OddsFormat.American && _ml[2] > 0 ? '+': ''}
                  ${_ml[2]}
                </h4>
              </span>
            </a>
        </div>`
    }
  }
  return result;
}

export const getOddsHDP = (_hdp, eventId, period, oddsFormat, dataTeam, isHasDrawML = true, classParlayRestriction = '') => {
  let result = '';
  const isHDPOnline = _hdp && _hdp[2] !== '';
  for(const oddsHDP of OddsConstant.hdpType) {
    result += 
      `<div>
        ${ _hdp
          ? 
            `<a class="odds-btn ${isHDPOnline ? '' : 'offline-game'} ${_hdp[oddsHDP.oddData] < 0 ? 'neg' : ''}"
              data-oddsid="${_hdp[7]}"
              data-odds="${_hdp[oddsHDP.oddData]}"
              data-team="${dataTeam[oddsHDP.id]}"
              ${classParlayRestriction}
              id="${eventId}|${period}|2|${oddsHDP.selectionType}|${_hdp[8] ? 1 : 0}|${_hdp[oddsHDP.ou]}"
            >
              <span>
                <h5>${_hdp[oddsHDP.ou]}</h5>
                <h4 class='${_hdp[oddsHDP.oddData] < 0 ? 'neg' : ''}'>
                  ${oddsFormat === OddsFormat.American && _hdp[oddsHDP.oddData] > 0 ? '+': ''}
                  ${_hdp[oddsHDP.oddData]}
                </h4>
              </span>
            </a>`
          : `<span class='no-odds hdp'/>`
        }
      </div>`;
  }
  if(isHasDrawML) {
    result += 
      `<div>
        <span class='no-odds'></span>
      </div>`
  }
  return result;
}

export const getOddsOU = (_ou, eventId, period, oddsFormat, dataTeam, isHasDrawML = true, classParlayRestriction = '') => {
  let result = '';
  const isOUOnline = _ou && _ou[0] !== '';
  for(const oddsOU of OddsConstant.ouType) {
    result += 
      `<div>
        ${_ou
          ? 
            `<span class='type'>${oddsOU.id === 0 ? i18next.t('O') : i18next.t('U')}</span>
            <a class="odds-btn ${isOUOnline ? '' : 'offline-game'} ${_ou[oddsOU.oddData] < 0 ? 'neg' : ''}"
              data-oddsid="${_ou[4]}"
              data-odds="${_ou[oddsOU.oddData]}"
              data-team="${dataTeam[oddsOU.id]}"
              ${classParlayRestriction}
              id="${eventId}|${period}|3|${oddsOU.selectionType}|${_ou[5] ? 1 : 0}|${_ou[1]}"
            >
              <span>
                <h5>${_ou[0]}</h5>
                <h4 class='${_ou[oddsOU.oddData] < 0 ? 'neg' : ''}'>
                  ${oddsFormat === OddsFormat.American && _ou[oddsOU.oddData] > 0 ? '+': ''}
                  ${_ou[oddsOU.oddData]}
                </h4>
              </span>
            </a>`
          : `<span class='no-odds hdp'></span>`
        }
      </div>`
  }
  if(isHasDrawML) {
    result += 
      `<div>
        <span class='no-odds'></span>
      </div>`
  }
  return result;
}
 
export const getExtraTimeSoccer = (event, periodsDescription, sportId = 0, periodNum = 0, oddsFormat, lineIndex = 0, isParlay) => {
  const periodsMainOdds = Utils.getPeriodsMainOdds(sportId);

  if(periodNum > 0 || periodsMainOdds.length === 0) {
    return '';
  }

  const fetchPeriods = _.xor(periodsMainOdds, [0, 1]);
  const periodsEvent = Object.keys(event[EventDetail.periods]).map(Number);
  const periods = fetchPeriods.filter(period => periodsEvent.includes(period));
  const dataTeam = event[EventDetail.teamType];
  const eventId = event[EventDetail.id];
  const classParlayRestriction = isParlay ? `data-pl-res=${event[EventDetail.parlayRestriction]}` : '';
  let templateExtraTime = '';
  const runningState = RUNNING_STATE_EXTRA_TIME.includes(event[EventDetail.runningPeriod]) ? event[EventDetail.runningPeriod] : "";
  for(const period of periods) {
    const oddsPeriod = _.get(event, [EventDetail.periods, period], []);
    if(oddsPeriod.length > 0) {
      const _hdp = _.get(oddsPeriod, EventPeriodHDPOU.handicap, []);
      const _ou = _.get(oddsPeriod, EventPeriodHDPOU.totalOU, []);
      const _ml = _.get(oddsPeriod, EventPeriodHDPOU.moneyLine, []);
      const isHasDrawML = lineIndex === 0 && _ml && _ml[2];
      const periodDesc = Utils.getPeriodName(periodsDescription, sportId, period, true);
      const redCards = _.get(event, [EventDetail.periods, period, '10']);
      const score = _.get(event, [EventDetail.periods, period ,'9']);
      const statusPeriod = oddsPeriod[EventPeriodHDPOU.statusPeriod] ? `status_${oddsPeriod[EventPeriodHDPOU.statusPeriod]}` : "";
      const mlText = sportId === Constants.SOCCER_ID ? i18next.t('soccer:1x2') : (sportId === Constants.ESPORT_ID ? i18next.t('ML'): i18next.t('others:1x2'));
      templateExtraTime += `
        ${period === 3 && runningState ? renderHeader(event, runningState, score, redCards) : ''}
        <div class="line">
          <div class="line-header">
            <span class="bt-h">${periodDesc} ${mlText}</span>
            <span class="bt-h">${periodDesc} ${i18next.t('HDP')}</span>
            <span class="bt-h">${periodDesc} ${i18next.t('OU')}</span>
          </div>
          <div class="line-content ${statusPeriod}" data-period="${period}">
            <div class="bt">
              ${getOddsML(_ml, eventId, period, oddsFormat, dataTeam, lineIndex, classParlayRestriction)}
            </div>
            <div class="bt">
              ${getOddsHDP(_hdp[0], eventId, period, oddsFormat, dataTeam, isHasDrawML, classParlayRestriction)}
            </div>
            <div class="bt ou">
              ${getOddsOU(_ou[lineIndex], eventId, period, oddsFormat, dataTeam, isHasDrawML, classParlayRestriction)}
            </div>
          </div>
        </div>
      `;
    }
  }
  return templateExtraTime;
}


// WEBPACK FOOTER //
// ./src/app/common/template/OddsPageTemplates/TemplateHelper.js